import React from 'react';
import styles from './SkipToLocationLink.css';

export const SKIP_TO_CONTENT_ID = 'skip-to-content';

export const SkipToContentTarget = () => (
  <div id={SKIP_TO_CONTENT_ID} className={styles.showOnFocus} tabIndex="-1" />
);
